'use client';

import { SvgToUse } from "@/components/atoms/Buttons/WarningButton";
import React, { useState } from "react";
import ShareIcon from '~/icons/share.png';
import AmityLogo from '~/icons/amity-logo.png';
import Image from "next/image";
const ReferralHeader = ({ isCheckStatus = false }) => {
  const [showShareCard, setShowShareCard] = useState(false);

  const socialLinks = [
    { name: "Whatsapp", icon: "/_a/icons/socialMedia/whatsapp.svg", link: "https://api.whatsapp.com/send?text=Check%20out%20this%20referral%20program%20at%20Amity%20Online:%20https://amityonline.com/referral" },
    { name: "linkedIn", icon: "/_a/icons/socialMedia/linkedIn.svg", link: "https://www.linkedin.com/sharing/share-offsite/?url=https://amityonline.com/referral" },
    { name: "Facebook", icon: "/_a/icons/socialMedia/fb.svg" ,link: "https://www.facebook.com/sharer/sharer.php?u=https://amityonline.com/referral" },
    { name: "X", icon: "/_a/icons/socialMedia/X.svg", link: "https://twitter.com/intent/tweet?text=Check%20out%20this%20referral%20program%20at%20Amity%20Online&url=https://amityonline.com/referral" },
  ];

  return (
    <>
  {/* Header */}
  <header className="bg-[#1a325d] flex flex-col transition-all duration-500 mt-5 mb-3 rounded-xl">
    <div className="container mx-auto flex justify-between items-center py-4">
      <div className="logo-wrapper">
        <a href="/">
          <img src={AmityLogo.src} alt="Amity Logo" className="h-11" />
        </a>
      </div>
      <div className="header-content flex items-center gap-5">
        <div className="header-btn flex gap-5">
          <div
            className="cus-btn sm:hidden flex items-center border border-[#fff] font-semibold rounded-full px-4 py-1 text-[#fff] gap-2 cursor-pointer hover:shadow-lg"
            onClick={() => setShowShareCard(true)}
          >
            <span>SHARE</span>
            <img src={ShareIcon.src} alt="Share Icon" height={20} width={20} className="filter invert" />
          </div>
          {isCheckStatus ? (
            <a
              href="/referral/check-status"
              className="cus-btn  text-[#1A325D] rounded-full px-5 py-2 font-semibold flex items-center gap-2 hover:shadow-lg"
              style={{backgroundColor:"#ffc907"}}
            >
              <span style={{ fontSize: '0.8rem' }}>CHECK STATUS</span>
              <SvgToUse type={"normal"} iconDirection={"right"} />
            </a>
          ) : null}
        </div>
      </div>
    </div>
  </header>

  {/* Mobile Sticky Share Button */}
  <div 
    className="fixed z-10 top-[20rem] border border-[#1A325D] right-0 hidden w-10 h-10 bg-[#fff] text-white sm:flex items-center justify-center rounded-full shadow-lg cursor-pointer"
    onClick={() => setShowShareCard(true)}
  >
    <img src={ShareIcon.src} alt="Share" className="w-6 h-6" />
  </div>
  {/* Share Card */}
  {showShareCard && (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
    onClick={() => setShowShareCard(false)}>
      <div className="bg-white rounded-[1.5vw] p-10 w-[27rem] lg:w-[28%] shadow-lg relative"
      onClick={(e) => e.stopPropagation()}>
        <div
          className="absolute top-2 right-5 hover:text-blue cursor-pointer"
          onClick={() => setShowShareCard(false)}
        >
          <svg style={{marginTop:'1rem'}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" fill="#1A325D" height={20} width={20}><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
        </div>
        <h2 className="text-lg font-semibold text-start font-raleway">Share this</h2>
        <div className="border-b-2 border-grey mb-5"></div>

        {/* Social Links */}
        <div className="flex flex-col">
          {socialLinks.map((social, index) => (
            <div key={index}>
              <a
                href={social.link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center text-sm gap-3 text-black hover:bg-gray-100 rounded-lg"
              >
                <img className="w-[18px] h-[18px]"  src={social.icon} alt="icons" />
                <span className=" text-[1rem] text-[#666] font-raleway">{social.name}</span>
              </a>
              <div className={index !== socialLinks.length - 1 ? 'border-b-2 border-grey my-2' : 'my-2'}></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )}
</>
  );
};

export default ReferralHeader;

